<template>
  <div class="giftbox-container-phone w-100">
    <div class="d-flex justify-content-center align-items-center">
      <div class="d-flex flex-column justify-content-between align-items-start w-100">
        <span class="merriweather-bold-p16 w-100 text-center pb-3">Nos coffrets cadeaux</span>
        <div class="giftbox-section px-4 py-3">
          <div
            v-for="giftbox in giftbox"
            :key="giftbox[0]"
            @click="goToLink(giftbox[1])"
          >
            <div
              class="raleway-medi-p15 text-center item-link"
            >
              {{ giftbox[0] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'SelectionsList',
  data() {
    return {
      giftbox: [
        ["Particuliers", "/coffrets-cadeaux"],
        ["Entreprises", "/coffrets-cadeaux-entreprise"],
        ["CSE & Collectivités", "/coffrets-cadeaux-cse"]
      ]
    }
  },
  methods: {
    goToLink(link) {
      window.open(link, '_blank');
    }
  }
}
</script>

<style scoped>
.giftbox-container-phone {
  gap: 40px;

  .giftbox-section {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .raleway-bold-16{
    font-family: 'Raleway';
    font-weight: 700;
    font-size: 16px;
  }
}
</style>